import './common'
import '~components/b-profile-favorites/b-profile-favorites'
import '~components/b-profile-history/b-profile-history'
import '~components/b-profile/b-profile'

import '../scss/style.scss';
